import React from "react";
import { useUser } from "../context/UserContext";
import ProtectedRoute from "./ProtectedRoute";

const ConditionalProtectedRoute = ({
  workerComponent: WorkerComponent,
  clientComponent: ClientComponent,
}) => {
  const { clientUser, workerUser } = useUser();
  const user = clientUser || workerUser;

  let Dashboard = null;
  if (user?.userType === "worker") {
    Dashboard = WorkerComponent;
  } else if (user?.userType === "client") {
    Dashboard = ClientComponent;
  }

  if (!Dashboard) return null;

  return (
    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  );
};

export default ConditionalProtectedRoute;
